import MCP from '@/components/Tools/MCP';

const ToolsList = () => {
  return (
    <div className="p-6">
      <MCP />
    </div>
  );
};

export default ToolsList;
